import * as React from 'react';
import Svg, {Path} from 'react-native-svg';
import Styles from 'src/components/Styles';

function Help() {
  return (
    <Svg width={24} height={24} viewBox="0 0 24 24" fill="none">
      <Path
        d="M19.313 12a7.312 7.312 0 10-14.625 0 7.312 7.312 0 0014.625 0zM3 12a9 9 0 1118 0 9 9 0 01-18 0zm5.97-3.189A1.972 1.972 0 0110.826 7.5h2.05a2.218 2.218 0 011.103 4.145l-1.135.65a.846.846 0 01-.844.83.842.842 0 01-.844-.844v-.474c0-.303.162-.58.426-.732l1.557-.893a.532.532 0 00-.264-.991h-2.05a.277.277 0 00-.263.186l-.014.043a.844.844 0 01-1.589-.563l.014-.042-.003-.004zm1.905 6.564a1.125 1.125 0 112.25 0 1.125 1.125 0 01-2.25 0z"
        fill={Styles.Colors.PayNew.black01}
      />
    </Svg>
  );
}

const HelpIcon = React.memo(Help);

export default HelpIcon;
